import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

function Enquiries() {

  const [enquiries, setEnquiries] = useState([]);

  useEffect(() => {
    axios
      .get("/api/enquiries")
      .then((response) => {
        setEnquiries(response.data);
      })
      .catch((error) => {
        console.error("Error loading enquiries:", error);
      });
  }, []);

  // ================= EXPORT TO EXCEL =================

  const handleExportExcel = () => {

    if (enquiries.length === 0) {
      alert("No enquiries available to export.");
      return;
    }

    const excelData = enquiries.map((enquiry, index) => ({
      "S.No": index + 1,
      "Name": enquiry.name || "",
      "Email": enquiry.email || "",
      "Phone": enquiry.phone || "",
      "Subject": enquiry.subject || "",
      "Message": enquiry.message || "",
      "Submitted Date": enquiry.submittedAt || "",
      "Status": enquiry.status || ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Enquiries"
    );

    worksheet["!cols"] = [
      { wch: 8 },
      { wch: 25 },
      { wch: 30 },
      { wch: 18 },
      { wch: 30 },
      { wch: 60 },
      { wch: 25 },
      { wch: 15 }
    ];

    XLSX.writeFile(
      workbook,
      "Enquiries.xlsx"
    );
  };

  return (
    <div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px"
        }}
      >

        <h2>Enquiries</h2>

        <button
          onClick={handleExportExcel}
          style={{
            padding: "8px 14px",
            border: "none",
            borderRadius: "5px",
            background: "#6b1f1f",
            color: "white",
            cursor: "pointer",
            fontSize: "14px"
          }}
        >
          📊 Export Excel
        </button>

      </div>

      {enquiries.length === 0 ? (
        <p>No enquiries found.</p>
      ) : (
        enquiries.map((enquiry) => (
          <div key={enquiry.id}>

            <p>
              <b>Name:</b> {enquiry.name}
            </p>

            <p>
              <b>Email:</b> {enquiry.email}
            </p>

            <p>
              <b>Phone:</b> {enquiry.phone}
            </p>

            <p>
              <b>Subject:</b> {enquiry.subject}
            </p>

            <p>
              <b>Message:</b> {enquiry.message}
            </p>

            <hr />

          </div>
        ))
      )}

    </div>
  );
}

export default Enquiries;